import {Pipe, PipeTransform} from "@angular/core";
import {quote} from './string-utils';

@Pipe({name: "literal"})
export class LiteralPipe implements PipeTransform {
    transform(value: string) {
        return quote(value || "");
    }
}
